import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/common/dataTable";
import { all_routes } from "../../../router/all_routes";
import {
  FeeStatus,
  FeeStatusBadge,
} from "../../../feescollection/components/FeeStatusBadge";
import FeeConfigModal from "../components/FeeConfigModal";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import CommonSelect from "../../../../core/common/commonSelect";
import { useFeeConfig } from "../hooks/useFeeConfig";

const FeesConfiguration = () => {
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [attachedCenters, setAttachedCenters] = useState<any[]>([]);

  const { feeConfigs, loading, paginationData } = useFeeConfig({
    page: pageNumber,
    size: recordsPerPage,
    search: search,
  });

  // console.log(feeConfigs, 'fcccc--')

  const handleSearchChange = (text: string) => {
    setSearch(text);
  };

  const handlePageChange = (page: number, pageSize?: number) => {
    setPageNumber(page);
    if (pageSize) setRecordsPerPage(pageSize);
  };

  const columns = [
    {
      title: "S. No",
      render: (_: any, __: any, index: number) => index + 1,
      sorter: (a: any, b: any) => a.id - b.id,
    },
    {
      title: "Course Name",
      dataIndex: ["course", "name"],
      sorter: (a: any, b: any) => a.course.name.localeCompare(b.course.name),
    },
    {
      title: "No. of Levels",
      dataIndex: ["course", "stages"],
      render: (stages: number) => `${stages} Levels`,
      sorter: (a: any, b: any) => a.course.stages - b.course.stages,
    },
    {
      title: "Total Fees",
      dataIndex: "stageFees",
      render: (stageFees: any[]) => {
        if (!stageFees || !stageFees.length) return "-";
        const totalFees = stageFees.reduce((sum, fee) => sum + fee.amount, 0);
        return `₹${totalFees.toFixed(2)}`;
      },
      sorter: (a: any, b: any) => {
        const aTotal = a.stageFees.reduce(
          (sum: number, fee: any) => sum + fee.amount,
          0
        );
        const bTotal = b.stageFees.reduce(
          (sum: number, fee: any) => sum + fee.amount,
          0
        );
        return aTotal - bTotal;
      },
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (status: string) => (
    //     <FeeStatusBadge status={(status || "").toLowerCase() as FeeStatus} />
    //   ),
    //   sorter: (a: any, b: any) =>
    //     (a.status || "").localeCompare(b.status || ""),
    // },
    {
      title: "Action",
      render: (record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#attach-modal"
                    onClick={() => {
                      setSelectedId(record.id);
                      setAttachedCenters(record.atachedToCenters);
                    }}
                  >
                    <i className="ti ti-link me-2" />
                    Attach To Centers
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#detach-modal"
                    onClick={() => {
                      setSelectedId(record.id);
                      setAttachedCenters(record.atachedToCenters);
                    }}
                  >
                    <i className="ti ti-unlink me-2" />
                    Detach From Centers
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to={all_routes.editFeeConfiguration.replace(
                      ":id",
                      record.id.toString()
                    )}
                  >
                    <i className="ti ti-edit me-2" />
                    Edit Fee
                  </Link>
                </li>
                {/* <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                    onClick={() => setSelectedId(record.id)}
                  >
                    <i className="ti ti-trash me-2" />
                    Delete
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  // Options for filter dropdowns
  const courseOptions = [
    { value: "mental-arithmetic", label: "Mental Arithmetic" },
    { value: "tiny-dots", label: "Tiny Dots" },
  ];

  const levelOptions = Array.from({ length: 10 }, (_, i) => ({
    value: `level-${i + 1}`,
    label: `Level ${i + 1}`,
  }));

  const sessionOptions = [
    { value: "january", label: "January" },
    { value: "february", label: "February" },
    { value: "march", label: "March" },
  ];

  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "pending", label: "Pending" },
  ];

  const handleApplyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    console.log("Applying filters...");
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Course Level Fee</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Fee Configuration</li>
                <li className="breadcrumb-item active">Course Level Fee</li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
            <div className="mb-2">
              <Link
                to={all_routes.addFeeConfiguration}
                className="btn btn-primary d-flex align-items-center"
              >
                <i className="ti ti-square-rounded-plus me-2" />
                Add Course Fee
              </Link>
            </div>
          </div>
        </div>

        {/* Fee Configuration Table */}
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
            <h4 className="mb-3">Level Fee List</h4>
            <div className="d-flex align-items-center flex-wrap">
              {/* <div className="input-icon-start mb-3 me-2 position-relative">
                <PredefinedDateRanges />
              </div> */}
              <div className="dropdown mb-3 me-2">
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  <i className="ti ti-filter me-2" />
                  Filter
                </Link>
                <div className="dropdown-menu drop-width">
                  <form>
                    <div className="d-flex align-items-center border-bottom p-3">
                      <h4>Filter</h4>
                    </div>
                    <div className="p-3 border-bottom">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Course</label>
                            <CommonSelect
                              className="select"
                              options={courseOptions}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Level</label>
                            <CommonSelect
                              className="select"
                              options={levelOptions}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-0">
                            <label className="form-label">Session</label>
                            <CommonSelect
                              className="select"
                              options={sessionOptions}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-0">
                            <label className="form-label">Status</label>
                            <CommonSelect
                              className="select"
                              options={statusOptions}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 d-flex align-items-center justify-content-end">
                      <Link to="#" className="btn btn-light me-3">
                        Reset
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-primary"
                        onClick={handleApplyClick}
                      >
                        Apply
                      </Link>
                    </div>
                  </form>
                </div>
              </div>

              {/* Add Sort By Dropdown */}
              <div className="dropdown mb-3">
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-sort-ascending-2 me-2" />
                  Sort by A-Z
                </Link>
                <ul className="dropdown-menu p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1 active">
                      Ascending
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Descending
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Recently Viewed
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Recently Added
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card-body p-0 py-3">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <Table
                dataSource={feeConfigs}
                columns={columns}
                Selection={false}
                rowKey="id"
                onSearchChange={handleSearchChange}
                pagination={{
                  pageSize: recordsPerPage,
                  current: pageNumber,
                  total: paginationData.totalItems,
                  onChange: handlePageChange,
                  pageSizeOptions: ["All", 10, 20, 30],
                }}
              />
            )}
          </div>
        </div>
      </div>

      {/* Add Fee Configuration Modal */}
      <FeeConfigModal
        id={selectedId}
        attachedCenters={attachedCenters}
        courseId={feeConfigs.find(config => config.id === Number(selectedId))?.course?.id}
      />
    </div>
  );
};

export default FeesConfiguration;
